import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import Drawer from '@shell/components/Drawer/Chrome.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import Tabbed from '@shell/components/Tabbed/index.vue';
import YamlTab, { Props as YamlProps } from '@shell/components/Drawer/ResourceDetailDrawer/YamlTab.vue';
import { useDefaultConfigTabProps, useDefaultYamlTabProps } from '@shell/components/Drawer/ResourceDetailDrawer/composables';
import ConfigTab from '@shell/components/Drawer/ResourceDetailDrawer/ConfigTab.vue';
import { computed, ref } from 'vue';
import RcButton from '@components/RcButton/RcButton.vue';
import StateDot from '@shell/components/StateDot/index.vue';
import { ResourceDetailDrawerProps } from '@shell/components/Drawer/ResourceDetailDrawer/types';

const editBttnDataTestId = 'save-configuration-bttn';
const componentTestid = 'configuration-drawer-tabbed';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    resource: {},
    onClose: { type: Function }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore();
const i18n = useI18n(store);

const yamlTabProps = ref<YamlProps | null>(null);
const configTabProps = useDefaultConfigTabProps(props.resource);

useDefaultYamlTabProps(props.resource).then((props) => {
  yamlTabProps.value = props;
});

const title = computed(() => {
  const resourceType = store.getters['type-map/labelFor']({ id: props.resource.type });
  const resourceName = props.resource.nameDisplay;

  return i18n.t('component.drawer.resourceDetailDrawer.title', { resourceType, resourceName });
});

const activeTab = ref<string>(configTabProps ? 'config-tab' : 'yaml-tab');

const isConfig = computed(() => {
  return activeTab.value === 'config-tab';
});

const action = computed(() => {
  const ariaLabel = isConfig.value ? i18n.t('component.drawer.resourceDetailDrawer.ariaLabel.editConfig') : i18n.t('component.drawer.resourceDetailDrawer.ariaLabel.editYaml');
  const label = isConfig.value ? i18n.t('component.drawer.resourceDetailDrawer.ariaLabel.editConfig') : i18n.t('component.drawer.resourceDetailDrawer.ariaLabel.editYaml');
  const action = isConfig.value ? () => props.resource.goToEdit() : () => props.resource.goToEditYaml();

  return {
    ariaLabel,
    label,
    action
  };
});

const canEdit = computed(() => {
  return isConfig.value ? props.resource.canEdit : props.resource.canEditYaml;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Drawer, {
    class: "resource-detail-drawer",
    ariaTarget: title.value,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    title: _withCtx(() => [
      _createVNode(StateDot, {
        color: _ctx.resource.stateSimpleColor,
        class: "mmr-3"
      }, null, 8, ["color"]),
      _createTextVNode(" " + _toDisplayString(title.value), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(Tabbed, {
        class: "tabbed",
        useHash: false,
        showExtensionTabs: false,
        componentTestid: componentTestid,
        onChanged: _cache[0] || (_cache[0] = ({selectedName}) => {activeTab.value = selectedName;})
      }, {
        default: _withCtx(() => [
          (_unref(configTabProps))
            ? (_openBlock(), _createBlock(ConfigTab, _normalizeProps(_mergeProps({ key: 0 }, _unref(configTabProps))), null, 16))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (yamlTabProps.value)
            ? (_openBlock(), _createBlock(YamlTab, _normalizeProps(_mergeProps({ key: 1 }, yamlTabProps.value)), null, 16))
            : _createCommentVNode("", true)
        ]),
        _: 1,
        __: [2]
      })
    ]),
    "additional-actions": _withCtx(() => [
      (canEdit.value)
        ? (_openBlock(), _createBlock(RcButton, {
            key: 0,
            primary: true,
            "aria-label": action.value.ariaLabel,
            "data-testid": editBttnDataTestId,
            onClick: action.value.action
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(action.value.label), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1,
    __: [3,4]
  }, 8, ["ariaTarget"]))
}
}

})